import request from '@/utils/request'

/**
 * 创建角色
 */
export const addRole = async (data) =>
  request({ url: '/role/add', method: 'POST', data })

/**
 * 编辑角色
 */
export const editRole = async (data) =>
  request({ url: '/role/edit', method: 'POST', data })

/**
 * 删除角色
 */
export const deleteRole = async (data) =>
  request({ url: '/role/delete', method: 'POST', data })

/**
 * 角色列表
 */
export const getRoleList = async (data) =>
  request({ url: '/role/list', method: 'POST', data })

/**
 * 角色详情
 */
export const getRoleDetail = async (data) =>
  request({ url: '/role/detail', method: 'POST', data })

/**
 * 当前子账号获取自己的权限
 */
export const getMyPermissions = async (data) =>
  request({ url: '/role/myPermissions', method: 'POST', data })
